import React, { ReactElement } from 'react';
import './tooltip-content.scss';
import Icon from 'atomic/icon';

export interface TooltipContentProps {
    title: JSX.Element;
    onClose: () => void;
}

const TooltipContent: React.FC<TooltipContentProps> = ({
    title,
    onClose,
    children
}): ReactElement => (
    <div className="tooltip-content">
        <div className="tooltip-content__title">
            <div className="tooltip-content__title-text">
                {title}
            </div>
            <Icon className="tooltip-content__title-exit" name="x" color="dark"
                size={18} onClick={onClose} role="button"
                aria-label="Zamknij" tabIndex={0}
            />

        </div>
        {children}
    </div>
);

export default TooltipContent;
